<template>
  <div class="modal-email">
    <div class="modal-header">
      <h3 class="title">Kreiraj poruku za sve stanare zajednice</h3>
    </div>
    <div class="content">
      <select class="form-control custom-select to" v-model="selectedCommunity">
        <option disabled value>Izaberite zajednicu</option>
        <option
          v-for="community of getCommunities"
          :key="community.id"
          v-bind:value="community.id"
          >{{ community.name }}</option
        >
      </select>
      <textarea
        class="form-control"
        rows="3"
        placeholder="Sadržaj poruke"
        v-model="messageBody"
      ></textarea>
    </div>
    <div class="modal-footer">
      <transition enter-active-class="animated shake">
        <div v-if="errorMsg.length > 0" class="error">{{ errorMsg }}</div>
      </transition>
      <button type="submit" class="btn btn-danger" @click="closeModal">
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="sendMessages"
        :disabled="isLoading"
      >
        <div v-if="!isLoading">Pošalji</div>
        <div v-else>
          <spinner size="20" line-fg-color="#00796b" class="spinner"></spinner>
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import axios from '@/axios/axios.js';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';
import checkbox from '@/components/common/Checkbox';
export default {
  name: 'EmailModal',
  components: {
    uploadButton,
    checkbox
  },
  computed: {
    getCommunities() {
      return this.$store.getters.getCommunitiesImploded;
    }
  },
  data() {
    return {
      selectedCommunity: '',
      selection: true,
      searchCriteria: '',
      showDropdown: false,
      messageBody: '',
      errorMsg: '',
      isLoading: false
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    getFiles(load) {
      for (const l of load) {
        this.attachments.push(l);
      }
    },
    removeUploadedFile(index) {
      this.attachments.splice(index, 1);
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    async sendMessages() {
      this.errorMsg = '';
      if (this.isLoading || !this.validateInput()) {
        return;
      }

      this.isLoading = true;

      try {
        let res = await axios.post('member/get-members-by-community', {
          community_id: this.selectedCommunity,
          active: 1
        });
        let memberIds = [];
        let managerMemberId;
        let community = this.$store.getters.getCommunities.filter(
          c => c.community_id == this.selectedCommunity
        );
        community = community[0];
        for (const member of res.data) {
          if (member.user_id == community.manager_id) {
            managerMemberId = member.id;
            continue;
          }
          memberIds.push(member.id);
        }

        if (memberIds.length == 0) {
          this.errorMsg = 'Zajednica nema ni jednog člana';
          this.isLoading = false;
          return;
        }

        // ako slucajno nije nasao member id za upravnika
        if (!managerMemberId) {
          this.showFailModal();
          this.isLoading = false;
        }
        await axios.post('post/group-message', {
          body: this.messageBody,
          community_id: this.selectedCommunity,
          member_id: managerMemberId,
          post_type: 4,
          direct_post_receiver_ids: memberIds
        });
        this.showSuccessModal();
        this.messageBody = '';
        this.closeModal();
        this.isLoading = false;
      } catch (error) {
        this.showFailModal();
        this.isLoading = false;
      }
    },
    validateInput() {
      return (
        !this.isEmpty(this.selectedCommunity, 'Morate izabrati zajednicu') &&
        !this.isEmpty(this.messageBody, 'Sadržaj je obavezan')
      );
    },
    getSelectedEmails() {
      const emails = [];
      for (let member of this.getSelectedMembers) {
        emails.push(member.email);
      }
      return emails;
    },
    isEmpty(element, errorMsg) {
      let isEmpty = false;
      if (Array.isArray(element)) {
        isEmpty = element.length == 0;
      } else if (typeof element == 'string') {
        isEmpty = element == '';
      } else {
        throw new Error(
          '[isEmpty] Unsupported type. Array or string are expected'
        );
      }
      if (isEmpty) {
        this.errorMsg = errorMsg;
      }
      return isEmpty;
    }
  },
  directives: {
    'click-outside': {
      priority: 700,
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = event => {
          if (
            !(
              el == event.target ||
              el.contains(event.target) ||
              vnode.context.$refs.dropdown.contains(event.target)
            )
          ) {
            vnode.context[binding.expression]();
          }
        };

        el.handleEscapeKey = event => {
          if (event.key === 'Escape') {
            vnode.context[binding.expression]();
          }
        };

        document.body.addEventListener('click', el.clickOutsideEvent);
        document.body.addEventListener('touchstart', el.clickOutsideEvent);
        document.body.addEventListener('keyup', el.handleEscapeKey);
      },
      unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        document.body.removeEventListener('touchstart', el.clickOutsideEvent);
        document.body.addEventListener('keyup', el.handleEscapeKey);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-email {
  .modal-header {
    width: fit-content;
    .to h3 {
      color: rgb(46, 45, 45);
    }
  }

  .title {
    margin-right: 8px;
    color: rgb(46, 45, 45);
  }

  .content {
    padding: 1.5rem 0;
    .margin-bottom-1 {
      margin-bottom: 1rem;
    }
    .to {
      margin-bottom: 1.5rem;
      position: relative;

      .to-wrapper {
        border: 1px solid #ced4da;
        border-radius: 4px;
        min-height: 38px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 5px;
        .no-emails {
          color: rgb(88, 88, 88);
        }
        .email-bubble {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 40px;
          border: 1px solid var(--primary-color);
          font-weight: 900;
          font-size: 12px;
          z-index: 5;
          max-height: 24px;
          color: rgb(88, 88, 88);
          margin: 4px 0;
          .bubble-x {
            padding-left: 5px;
          }
          .bubble-x:hover {
            color: black;
            cursor: pointer;
          }
        }

        .email-bubble:hover {
          cursor: default;
        }

        .email-bubble:not(:first-of-type) {
          margin-left: 5px;
        }
      }

      .to-wrapper {
        cursor: text;
      }

      .dropdown {
        position: absolute;
        border-radius: 4px;
        border: 1px solid #ced4da;
        background-color: white;
        min-width: 60%;
        max-width: 100%;
        // box-shadow: 0 1px 2px 2px rgba(60, 64, 67, 0.149);
        .input-wrapper {
          position: relative;
          .to-input {
            border: none;
            border-radius: 0;
            width: 100%;
            background-color: #f5f5f54d;
          }

          .to-input:focus {
            box-shadow: none;
          }

          .btn--dropdown {
            position: absolute;
            top: 3px;
            right: 10px;
            font-size: 12px;
            width: 80px;
            height: 30px;
            text-align: center;
            background-color: transparent;
          }

          .btn--dropdown:focus,
          .btn--dropdown:active {
            outline: none;
            box-shadow: none;
          }

          .btn--select {
            border: 1px solid var(--primary-color);
            color: black;
          }

          .btn--select:hover {
            background-color: var(--primary-color);
            color: white;
          }
        }

        .members-wrapper {
          max-height: 190px;
          overflow-y: auto;

          .member {
            padding: 5px 5px;
            display: flex;
            justify-content: space-between;
            position: relative;
            .basic {
              display: flex;
              flex-direction: column;
              .email {
                font-size: 15px;
                color: #5e5e5e;
              }
            }

            .empty-space {
              width: 50px;
            }

            .description {
              display: flex;
              flex-direction: column;
              position: relative;
              // align-items: flex-end;
              .desc {
                color: #424242;
                font-size: 16px;
              }
            }
            .desc-cb {
              position: absolute;
              bottom: 25px;
              right: 20px;
              padding-left: 0;
              margin-bottom: 0;
            }
          }

          .empty-list {
            height: 35px;
            padding: 5px;
          }
        }

        .member:hover {
          background-color: #ececec;
          cursor: pointer;
        }
      }
    }

    .upload-area {
      margin-top: 5px;
      padding: 5px 0;

      .no-files {
        padding: 0 5px;
      }
      .uploaded {
        background-color: rgb(241, 241, 241);
        border-radius: 4px;
      }
      .file {
        font-size: 15px;
        width: 100%;
        display: inline-flex;
        align-items: center;
        padding: 0 5px;
        p {
          word-wrap: break-word;
          margin-bottom: 2px;
        }

        .del--mod {
          margin-left: auto;

          cursor: pointer;
          color: red;
        }
      }

      .file:not(:last-of-type) {
        border-bottom: solid 1px lightgray;
      }
    }
  }

  .modal-footer {
    padding: 1rem 0;

    .error {
      margin-right: auto;
      color: red;
    }

    .btn--mod {
      min-width: 71px;
      min-height: 38px;
    }
  }
}
</style>
